// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2pR3O","checkmark":"Checkbox_checkmark__10-z5","filterCheckbox":"Checkbox_filterCheckbox__EBPHq"};